module.exports = __webpack_public_path__ + "img/shop.bb75ea28.png";